export const ensureHtmlWrapped = (input: string): string => {
  if (typeof input !== 'string' || !input.trim()) return '<p></p>';

  const trimmed = input.trim();

  const singleOuterTag = /^<([a-zA-Z][\w-]*)(\s[^>]*)?>[\s\S]*<\/\1>$/;
  if (singleOuterTag.test(trimmed)) return trimmed;

  if (/<\/?[a-zA-Z][\w-]*\b[^>]*>/.test(trimmed)) return trimmed;

  return `<p>${trimmed}</p>`;
};
